export default __webpack_public_path__ + "static/media/WinnerResult.97914985.svg";